export var PRODUCT_GRID_VIEW_STORAGE_KEY = 'salesbook-product-grid-view';
export var PRODUCT_GRID_VIEW_UI_MODES = ['grid6', 'grid8'];
var STORED_MODES = ['editorial', 'grid4', 'grid6', 'grid8'];
export function readProductGridView() {
    try {
        var stored = localStorage.getItem(PRODUCT_GRID_VIEW_STORAGE_KEY);
        if (stored === 'grid8') {
            return 'grid8';
        }
        if (stored === 'grid6') {
            return 'grid6';
        }
        // Legacy grid4 / editorial preferences fall back to default grid6
        if (stored && STORED_MODES.indexOf(stored) !== -1) {
            return 'grid6';
        }
    }
    catch (_a) {
        /* ignore */
    }
    return 'grid6';
}
export function writeProductGridView(mode) {
    try {
        localStorage.setItem(PRODUCT_GRID_VIEW_STORAGE_KEY, mode);
    }
    catch (_a) {
        /* ignore */
    }
}
export function plClassName(mode) {
    return "pl pl--view-".concat(mode);
}
export function editorialItemClass(index) {
    return index % 6 < 2
        ? 'pl-item__wrapper--editorial-half'
        : 'pl-item__wrapper--editorial-quarter';
}
export function wrapperClassName(mode, index, base) {
    if (base === void 0) { base = 'pl-item__wrapper ripple'; }
    if (mode !== 'editorial') {
        return base;
    }
    return "".concat(base, " ").concat(editorialItemClass(index));
}
export function isEditorialHalfItem(mode, index) {
    return mode === 'editorial' && index % 6 < 2;
}
//# sourceMappingURL=productGridView.js.map